import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import Button from "components/inputs/button"
import I18n from "shared/i18n"
import memo from "set-state-compare/build/memo"
import Routes from "shared/routes"
import {Subscription} from "models"
import SubscriptionsTable from "components/subscriptions/table"
import {useAdminLayout} from "components/admin/layout"
import useCanCan from "@kaspernj/api-maker/build/use-can-can"

/** @typedef {object} RoutesAdminSubscriptionsIndexProps */

/** @typedef {object} RoutesAdminSubscriptionsIndexState */

/**
 * @extends {ShapeComponent<RoutesAdminSubscriptionsIndexProps, RoutesAdminSubscriptionsIndexState>}
 */
class RoutesAdminSubscriptionsIndex extends ShapeComponent {
  setup() {
    const adminLayout = useAdminLayout()
    const canCan = useCanCan(() => [[Subscription, ["create"]]])

    this.canCan = canCan

    useMemo(() => {
      adminLayout?.setState({
        actions: this.actions(),
        active: "subscriptions",
        headerTitle: Subscription.modelName().human({count: 2})
      })
    }, [adminLayout, canCan.getCacheKey()])
  }

  render() {
    return (
      <div className="routes--admin-subscriptions--index">
        <SubscriptionsTable adminLayout />
      </div>
    )
  }

  actions() {
    const {canCan} = this.tt

    return (
      <>
        {canCan.can("create", Subscription) &&
          <Button
            className="new-subscription-button"
            icon="plus"
            label={I18n.t("js.routes.admin.subscriptions.index.add_new_subscription")}
            to={Routes.newAdminSubscriptionPath()}
          />
        }
      </>
    )
  }
}

export default memo(shapeComponent(RoutesAdminSubscriptionsIndex))
